/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".border-bottom[_ngcontent-%COMP%]{border-bottom:1px solid #ccc}"];
export { styles as styles };
